import { partial } from 'filesize';

const formatSize = partial({
    round: 0,
    spacer: '\u00a0'
});

export { formatSize }